<div class="container">
  <h3>{{ LL.appInstallSheet.title() }}</h3>
  <p class="pitch">{{ LL.appInstallSheet.body() }}</p>

  @if (target.kind === InstallTargetKind.NativeStore) {
    <!-- cs-store-badges renders its own <a target="_blank"> anchors that
         navigate to the store URL natively; the (click) on the host fires
         only telemetry + dismiss so we don't double-navigate. -->
    <cs-store-badges
      [iosInstallUrl]="iosInstallUrl"
      [androidInstallUrl]="androidInstallUrl"
      (click)="onStoreCtaClicked()">
    </cs-store-badges>
    <!-- The "Open in app" CTA is a real anchor (not a cs-button) so the
         browser reliably hands the App Link to the OS; HTML5 forbids
         nesting a <button> inside <a>, so we render an anchor styled to
         look like a primary cs-button instead.
         Only rendered when the target supplies a URL (openCtaHref) — Android
         does, iOS deliberately does not (#5660); see
         design-docs/install-affordances.md, "Why iOS has no Open-in-app link". -->
    @if (openCtaHref) {
      <a class="open-in-app-anchor primary" [href]="openCtaHref" target="_blank" rel="noopener"
         (click)="onOpenCtaClicked()">
        {{ LL.appInstallSheet.openInAppLink() }}
      </a>
    }
  }

  @if (target.kind === InstallTargetKind.NativeOpen) {
    <a class="open-in-app-anchor primary" [href]="openCtaHref" target="_blank" rel="noopener"
       (click)="onOpenCtaClicked()">
      {{ LL.appInstallSheet.openInAppCta() }}
    </a>
  }

  <!-- the login page's "Don't have an account yet?" divider, separating the
       install / open actions from the stay-in-browser ones -->
  <div class="divider">{{ LL.appInstallSheet.notRightNow() }}</div>

  <cs-button large secondary fit-width
             [label]="LL.appInstallSheet.continueInBrowser()"
             (click)="onContinueInBrowserClicked()">
  </cs-button>

  <!-- #5707: startup sheet only — from Settings the user opened it on purpose -->
  @if (showDontShowAgain) {
    <cs-button medium tertiary neutral fit-width
               [label]="LL.appInstallSheet.dontShowAgain()"
               (click)="onDontShowAgainClicked()">
    </cs-button>
  }
</div>
